export const REDMINE_URL = `${process.env.REACT_APP_REDMINE_URL}`;

export const CURRENCY_OPTIONS = [
  { value: "USD", label: "USD - US Dollar" },
  { value: "PEN", label: "PEN - Peruvian Sol" },
];

export const LANGUAGE_OPTIONS = [
  { value: "en", label: "English" },
  { value: "es", label: "Spanish" },
];
